<template>
  <div class="page page-downloads content">
    <h1 class="page__title">{{ t('downloads.menuTitle') }}</h1>
    <Downloads />
  </div>
</template>

<script setup>
  import Downloads from '@/components/settings/Downloads.vue'
  import { useStrings } from '@/composables/useStrings.ts'

  const { t } = useStrings()
</script>

<style lang="scss">
  .page-downloads {
    max-width: $content-page-width;
  }
</style>
